import { StyleSheet } from 'aphrodite'

export default StyleSheet.create({
  button: {
    borderRadius: '27px',
    boxShadow: 'none',
    color: 'white',
    cursor: 'pointer',
    fontFamily: 'Public Sans, sans-serif',
    fontWeight: 'bold',
    fontSize: '13px',
    letterSpacing: '1px',
    lineHeight: '24px',
    padding: '7px 20px',
    textAlign: 'center',
  },
})
